export default __webpack_public_path__ + "static/principal-artists2-f94fc04cee0e7800efe37682eb59111e.jpg";